var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkCard',_vm._b({attrs:{"image":_vm.thumbnail,"title":_vm.$path('name', _vm.value),"badges":_vm.badges,"to":_vm.$attrs.to}},'LinkCard',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }